import { createReducer } from '@reduxjs/toolkit'
import { IStateCurrentOrganization } from './TReducer'
import { Actions_CurrentOrganization } from './Actions'

const initialState: IStateCurrentOrganization = {
  isLoading: false,
  data: null,
  responseInfo: null,
}

const ReducerCurrentOrganization = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_CurrentOrganization.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_CurrentOrganization.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_CurrentOrganization.store.saveCurrentOrganization, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
    .addCase(Actions_CurrentOrganization.store.clearCurrentOrganization, (state) => {
      state.data = null
    })
})

export default ReducerCurrentOrganization
